document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('quick-view-overlay');
  const modal   = document.getElementById('quick-view-modal');

  // Abrir modal
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('.quick-view-trigger');
    if (!trigger) return;
    const handle = trigger.dataset.handle;
    if (!handle) return;

    const res  = await fetch(`/products/${handle}.js`);
    const data = await res.json();
    renderModal(data);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  // Cerrar modal
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay || e.target.closest('.quick-view-close')) {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  function renderModal(p) {
    const variant = p.variants[0];
    const imgs    = p.images;

    modal.innerHTML = `
      <div class="quick-view-gallery">
        <img id="qv-main-img" src="${imgs[0]}" alt="${p.title}">
        <div class="thumbnails">
          ${imgs.map((img, i) => `<img src="${img}" class="${i===0?'active':''}" onclick="document.getElementById('qv-main-img').src='${img}';this.parentNode.querySelectorAll('img').forEach(x=>x.classList.remove('active'));this.classList.add('active')">`).join('')}
        </div>
      </div>
      <div class="quick-view-info">
        <button class="quick-view-close" aria-label="Cerrar">&times;</button>
        <div class="product-title">${p.title}</div>
        <div class="product-sku">${variant.sku || ''}</div>
        <div class="product-price" id="qv-price">${formatMoney(variant.price)}</div>

        ${p.options.map(opt => `
          <div class="variant-label">${opt.name}</div>
          <div class="variant-options" data-option="${opt.name}">
            ${opt.values.map(val => `
              <button class="variant-swatch" style="background:${isColor(val)?val:'#eee'}" title="${val}"
                onclick="selectOption(this,'${opt.name}','${val}',${JSON.stringify(p.variants)})">
                <span style="font-size:0.7rem;padding:2px 6px">${val}</span>
              </button>
            `).join('')}
          </div>
        `).join('')}

        <div class="variant-label">Cantidad</div>
        <div class="qty-selector">
          <button onclick="adjustQty(-1)">−</button>
          <input type="number" id="qv-qty" value="1" min="1">
          <button onclick="adjustQty(1)">+</button>
        </div>

        <a href="/products/${p.handle}" class="btn-details">VER MÁS DETALLES</a>
        <button class="btn-atc" id="qv-atc" data-variant="${variant.id}" onclick="addToCart(this)">AGREGAR AL CARRITO</button>
      </div>
    `;
  }

  window.adjustQty = (delta) => {
    const input = document.getElementById('qv-qty');
    input.value = Math.max(1, parseInt(input.value) + delta);
  };

  window.selectOption = (btn, optName, val, variants) => {
    btn.closest('.variant-options').querySelectorAll('.variant-swatch')
      .forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const selected = {};
    document.querySelectorAll('.variant-options').forEach(group => {
      const active = group.querySelector('.variant-swatch.active');
      if (active) selected[group.dataset.option] = active.title;
    });
    const match = variants.find(v =>
      v.options.every((o, i) => selected[document.querySelectorAll('.variant-options')[i]?.dataset.option] === o)
    );
    if (match) {
      document.getElementById('qv-price').textContent = formatMoney(match.price);
      document.getElementById('qv-atc').dataset.variant = match.id;
    }
  };

  window.addToCart = async (btn) => {
    const variantId = btn.dataset.variant;
    const qty       = parseInt(document.getElementById('qv-qty').value);
    btn.textContent = 'Agregando...';
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({id: variantId, quantity: qty})
    });
    btn.textContent = '✓ Agregado';
    // Actualizar contador del carrito
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    });
    setTimeout(() => btn.textContent = 'AGREGAR AL CARRITO', 2000);
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function isColor(val) {
    const s = new Option().style;
    s.color = val;
    return s.color !== '';
  }
});
